import {Injectable} from "@angular/core";
import {RutasWebServices} from "../../services/rutasWebServices";
import {md5} from '../../services/md5';
import { HttpClient,HttpHeaders } from  '@angular/common/http';
import { tap, map, catchError } from "rxjs/operators";

@Injectable()
export class DetalleFormatoService{
  
	constructor(private _http:HttpClient){}


  	getFormatoResultado(IdSisDeta:number, CodPlantilla:string, Estudio:number, esDinamico:number){
		let esFormatoDinamico = (esDinamico == 1 )?true:false;
		let params=$.param({IdSisDeta:IdSisDeta,CodPlantilla:CodPlantilla,Estudio:Estudio,esDinamico:esFormatoDinamico});
		let rutasWS = new RutasWebServices();
		//return this._http.get(rutasWS.urlWebService("ParaclinicosGetFormatoResultado")+'?'+params).map(res => res.json());
		return this._http.get(rutasWS.urlWebService("ParaclinicosGetFormatoResultado")+'?'+params).pipe(
			map(res => res),
			tap(res => {
				  
				},
				err => {
				  
				})
  		);
	}

	SavePlantillaEstatica(data:any){
		let params=data;
		let rutasWS = new RutasWebServices();
		//return this._http.post(rutasWS.urlWebService("SavePlantillaEstatica"),params).map(res => res.json());
		return this._http.post(rutasWS.urlWebService("SavePlantillaEstatica"),params).pipe(
			map(res => res),
			tap(res => {
				  
				},
				err => {
				  
				})
  		);
	}

	SavePlantillaDinamica(data:any){
		let params=data;
		let rutasWS = new RutasWebServices();
		//return this._http.post(rutasWS.urlWebService("SavePlantillaDinamica"),params).map(res => res.json());
		return this._http.post(rutasWS.urlWebService("SavePlantillaDinamica"),params).pipe(
			map(res => res),
			tap(res => {
				  
				},
				err => {
				  
				})
  		);
	}
 
}